

















import Vue from 'vue'
import { mapActions } from 'vuex'
import { Route } from 'vue-router'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import { AxiosResponse } from 'axios'
import BaseLayout from '@/layout/BaseLayout.vue'
import CenterFormPanel from '@/components/Common/CenterFormPanel.vue'
import UserRole from '@/components/User/UserRole.vue'
import store from '@/store'
import { UserActionTypes } from '@/store/modules/users/actions'
import { SystemUserRole } from '@/models/users'

async function updateData(to: Route, from: Route, next: () => void) {
  await store.dispatch(UserActionTypes.FetchRoles)
  next()
}

interface Data {
  email: string
  inviteUrl: string
  roleId: SystemUserRole
}

interface Methods {
  [UserActionTypes.Invite]: (payload: object) => Promise<AxiosResponse<boolean>>
  handleInvite: () => void
  handleCopy: () => void
}

export default Vue.extend<Data, Methods, {}, {}>({
  beforeRouteEnter: updateData,
  components: {
    BaseLayout,
    CenterFormPanel,
    UserRole,
  },
  data: function() {
    return {
      email: '',
      inviteUrl: 'https://foxgid.com/url_inv',
      roleId: SystemUserRole.User,
    }
  },
  methods: {
    ...mapActions([UserActionTypes.Invite]),
    handleInvite() {
      this[UserActionTypes.Invite]({
        email: this.email,
        role: this.roleId,
      }).then(() => (this.email = ''))
    },
    handleCopy() {
      navigator.clipboard.writeText(this.inviteUrl).then(() => {
        store.dispatch(ADD_TOAST_MESSAGE, {
          text: 'URL скопирован!',
          type: 'success',
        })
      })
    },
  },
  metaInfo: {
    title: 'Новое приглашение',
  },
})
